module.exports = __webpack_public_path__ + "static/media/knImgLogo.c39185a8.png";